import { Component, OnInit } from '@angular/core';
import { CurrentInfoService } from '../../services/current-info.service';
import { InitializationService } from '../../services/initialization.service';
import { CurrentOrderService } from '../../services/current-order.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-order-type',
  templateUrl: './order-type.component.html',
  styleUrls: ['./order-type.component.scss']
})
export class OrderTypeComponent implements OnInit 
{
  orderData:any;

  constructor
  (
    private currentinfoservice:CurrentInfoService, 
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private router:Router, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService
    ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.initializeTypes();
  }

  back()
  {
    this.navigationservice.back();
  }

  initializeTypes()
  {
    this.orderData = this.currentinfoservice.getOrderTypes();
  }

  setOrderType(type:number)
  {
    this.currentorderservice.setOrderType(type);

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/menuitens');
  }
}
